import { IRootState } from '../../../store'
import { ISpecialReportOptionsState } from '../store/options.types'
import { ICategories } from '../../specialReports/store/specialReports.types'

export const getSpecialReportOptionsSelector = (state: IRootState): ISpecialReportOptionsState =>
  state.options.specialReportOptions

export const getSpecialReportCategoriesSelector = (state: IRootState): ICategories =>
  state.options.specialReportOptions.categories

export const getSpecialReportSubCategoriesSelector = (state: IRootState): ICategories =>
  state.options.specialReportOptions.subCategories
